export default __webpack_public_path__ + "static/media/tab2-image4.51e21a01.png";